/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from 'react';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Pie } from '@ant-design/plots';
import { Spin, Tooltip } from 'antd';
import { useTranslation } from 'react-i18next';
import IconNoData from '../../../assets/Images/icons/icon-no-data';
export default function Category({ cookieCategoryDetail, isLoadingCate }) {
    const { t, i18n } = useTranslation();
    let lang = i18n.language;
    const [categoryInfo, setCategoryInfo] = useState([]);

    useEffect(() => {
        if (cookieCategoryDetail) {
            setCategoryInfo(
                [
                    {
                        type: t('COOKIE.Necessary'),
                        value: cookieCategoryDetail?.find(
                            (e) => e.type?.toLowerCase() === 'necessary'
                        )?.value,
                        total: cookieCategoryDetail?.find(
                            (e) => e.type?.toLowerCase() === 'anecessary'
                        )?.total,
                    },
                    {
                        type: t('COOKIE.Analytics'),
                        value: cookieCategoryDetail?.find(
                            (e) => e.type?.toLowerCase() === 'analytics'
                        )?.value,
                        total: cookieCategoryDetail?.find(
                            (e) => e.type?.toLowerCase() === 'analytics'
                        )?.total,
                    },
                    {
                        type: t('COOKIE.Marketing'),
                        value: cookieCategoryDetail?.find(
                            (e) => e.type?.toLowerCase() === 'marketing'
                        )?.value,
                        total: cookieCategoryDetail?.find(
                            (e) => e.type?.toLowerCase() === 'marketing'
                        )?.total,
                    },
                    {
                        type: t('COOKIE.OtherCookie'),
                        value: cookieCategoryDetail?.find(
                            (e) => e.type?.toLowerCase() === 'other cookie'
                        )?.value,
                        total: cookieCategoryDetail?.find(
                            (e) => e.type?.toLowerCase() === 'other cookie'
                        )?.total,
                    },
                ].reverse()
            );
        }
    }, [cookieCategoryDetail, lang]);

    const config = useMemo(() => {
        return {
            data: categoryInfo,
            angleField: 'value',
            colorField: 'type',
            color: ({ type }) => {
                switch (type) {
                    case t('COOKIE.Necessary'):
                        return '#44B6A5';
                    case t('COOKIE.Analytics'):
                        return '#61DDAA';
                    case t('COOKIE.Marketing'):
                        return '#9CE2DD';
                    case t('COOKIE.OtherCookie'):
                        return '#BAC2F2';
                    default:
                        return '#BAC2F2';
                }
            },
            radius: 1,
            width: 200,
            height: 200,
            innerRadius: 0.6,
            label: false,
            legend: false,
            interactions: [
                {
                    type: 'element-active',
                },
            ],
            statistic: false,
        };
    }, [categoryInfo]);

    return (
        <Spin spinning={isLoadingCate}>
            <div className="flex space-x-2 items-center pb-4 justify-between">
                <div className="font-semibold text-xl">
                    {t('COOKIE.CookieCategory')}
                </div>
                <div>
                    <Tooltip
                        placement="right"
                        overlayClassName="min-w-[300px]"
                        title={t('COOKIE.ShowsConsentForEachCookieCategory')}
                    >
                        <a className="bg-purple-light p-2 flex items-center justify-center rounded-lg text-purple">
                            <ExclamationCircleOutlined />
                        </a>
                    </Tooltip>
                </div>
            </div>
            {cookieCategoryDetail?.length <= 0 ? (
                <div className="text-center text-sm space-y-2 my-32">
                    <IconNoData />
                    <p className="text-[#65707A] text-[14px]">
                        {t('common.noData')}
                    </p>
                </div>
            ) : (
                <>
                    <Pie {...config} />
                    <div className="flex justify-between pt-4 pb-2 ">
                        <div className="flex items-center">
                            <svg
                                width="12"
                                height="13"
                                viewBox="0 0 12 13"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <circle cx="6" cy="6.5" r="6" fill="#44B6A5" />
                            </svg>
                            <div className="pl-2">{t('COOKIE.Necessary')}</div>
                        </div>
                        <div className="text-gray-500">
                            {cookieCategoryDetail?.find((e) =>
                                e.type?.toLowerCase().includes('necessary')
                            )?.value || 0}{' '}
                            (
                            {cookieCategoryDetail?.find((e) =>
                                e.type?.toLowerCase().includes('necessary')
                            )?.value
                                ? (
                                      (Number(
                                          cookieCategoryDetail?.find((e) =>
                                              e.type
                                                  ?.toLowerCase()
                                                  .includes('necessary')
                                          )?.value
                                      ) /
                                          Number(
                                              cookieCategoryDetail?.find((e) =>
                                                  e.type
                                                      ?.toLowerCase()
                                                      .includes('necessary')
                                              )?.total
                                          )) *
                                      100
                                  ).toFixed(2)
                                : '00.00'}{' '}
                            %)
                        </div>
                    </div>

                    <div className="flex justify-between pb-2">
                        <div className="flex items-center">
                            <svg
                                width="12"
                                height="13"
                                viewBox="0 0 12 13"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <circle cx="6" cy="6.5" r="6" fill="#61DDAA" />
                            </svg>
                            <div className="pl-2">{t('COOKIE.Analytics')}</div>
                        </div>
                        <div className="text-gray-500">
                            {cookieCategoryDetail?.find((e) =>
                                e.type?.toLowerCase().includes('analytics')
                            )?.value || 0}{' '}
                            (
                            {cookieCategoryDetail?.find((e) =>
                                e.type?.toLowerCase().includes('analytics')
                            )?.value
                                ? (
                                      (Number(
                                          cookieCategoryDetail?.find((e) =>
                                              e.type
                                                  ?.toLowerCase()
                                                  .includes('analytics')
                                          )?.value
                                      ) /
                                          Number(
                                              cookieCategoryDetail?.find((e) =>
                                                  e.type
                                                      ?.toLowerCase()
                                                      .includes('analytics')
                                              )?.total
                                          )) *
                                      100
                                  ).toFixed(2)
                                : '00.00'}{' '}
                            %)
                        </div>
                    </div>

                    <div className="flex justify-between pb-2">
                        <div className="flex items-center">
                            <svg
                                width="12"
                                height="13"
                                viewBox="0 0 12 13"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <circle cx="6" cy="6.5" r="6" fill="#9CE2DD" />
                            </svg>
                            <div className="pl-2">{t('COOKIE.Marketing')}</div>
                        </div>
                        <div className="text-gray-500">
                            {cookieCategoryDetail?.find((e) =>
                                e.type?.toLowerCase().includes('marketing')
                            )?.value || 0}{' '}
                            (
                            {cookieCategoryDetail?.find((e) =>
                                e.type?.toLowerCase().includes('marketing')
                            )?.value
                                ? (
                                      (Number(
                                          cookieCategoryDetail?.find((e) =>
                                              e.type
                                                  ?.toLowerCase()
                                                  .includes('marketing')
                                          )?.value
                                      ) /
                                          Number(
                                              cookieCategoryDetail?.find((e) =>
                                                  e.type
                                                      ?.toLowerCase()
                                                      .includes('marketing')
                                              )?.total
                                          )) *
                                      100
                                  ).toFixed(2)
                                : '00.00'}{' '}
                            %)
                        </div>
                    </div>

                    <div className="flex justify-between pb-2">
                        <div className="flex items-center">
                            <svg
                                width="12"
                                height="13"
                                viewBox="0 0 12 13"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <circle cx="6" cy="6.5" r="6" fill="#BAC2F2" />
                            </svg>
                            <div className="pl-2">
                                {t('COOKIE.OtherCookie')}
                            </div>
                        </div>
                        <div className="text-gray-500">
                            {cookieCategoryDetail?.find((e) =>
                                e.type?.toLowerCase().includes('other cookie')
                            )?.value || 0}{' '}
                            (
                            {cookieCategoryDetail?.find((e) =>
                                e.type?.toLowerCase().includes('other cookie')
                            )?.value
                                ? (
                                      (Number(
                                          cookieCategoryDetail?.find((e) =>
                                              e.type
                                                  ?.toLowerCase()
                                                  .includes('other cookie')
                                          )?.value
                                      ) /
                                          Number(
                                              cookieCategoryDetail?.find((e) =>
                                                  e.type
                                                      ?.toLowerCase()
                                                      .includes('other cookie')
                                              )?.total
                                          )) *
                                      100
                                  ).toFixed(2)
                                : '00.00'}{' '}
                            %)
                        </div>
                    </div>

                    <div
                        className="flex justify-between pt-2"
                        style={{ borderTop: '0.5px solid #E9EBF1' }}
                    >
                        <div className="font-bold">{t('Total')}</div>
                        <div className="col-span-1 text-gray-500">
                            {cookieCategoryDetail[0]?.total || 0} (100%)
                        </div>
                    </div>
                </>
            )}
        </Spin>
    );
}
